export default __webpack_public_path__ + "static/N0275-35ad11a377a4dfec410074d9f4265230.png";